import { Flex, css, styled } from '@creditas-ui/react';
import React from 'react';
import EjnFilterByRepossessionStartedDate from './EjnFilterByRepossessionStartedDate';
import EjnFilterBySentAt from './EjnFilterBySentAt';
import EjnFilterByStatus from './EjnFilterByStatus';
import ResetFilters from './ResetFilters';

const FiltersOptions = styled(Flex)(
  () => css`
    display: grid;
    grid-template-columns: repeat(3, minmax(200px, 1fr));
    grid-gap: 1rem;
    @media (max-width: 100px) {
      grid-template-columns: 1fr;
    }
  `,
);

const EjnFiltersComponent: React.FC = () => {
  return (
    <FiltersOptions>
      <EjnFilterByStatus />
      <EjnFilterBySentAt />
      <EjnFilterByRepossessionStartedDate />
      <ResetFilters />
    </FiltersOptions>
  );
};

const EjnFilters = React.memo(EjnFiltersComponent);

export default EjnFilters;
